import http from "lib/http/httpClient";

export const getRoles = async () => {
    try {
        const response = await http.get('/api/v1/cp/roles/');
        return response;
    } catch (error) {
        console.error('Error fetching roles:', error);
        throw error;
    }
};

export const getRoleMenus = async (roleId: string) => {
    try {
        const response = await http.get(`/api/v1/cp/menu/all/${roleId}`);
        return response;
    } catch (error) {
        console.error('Error fetching role menus:', error);
        throw error;
    }
};

export const toggleRoleMenuAccess = async (roleId: string, menuId: string) => {
    try {
        const response = await http.patch(`/api/v1/cp/roles/${roleId}/menu/${menuId}`);
        return response;
    } catch (error) {
        console.error('Error toggling role menu access:', error);
        throw error;
    }
};

export const createRole = async (roleData: any) => {
    try {
        const response = await http.post('/api/v1/cp/roles/', roleData);
        return response;
    } catch (error) {
        console.error('Error creating role:', error);
        throw error;
    }
};